import { artifactLaneLabel, waveAdvanceCommands, waveProgress } from "../lib/artifactWaveProgress.js";

export default function ArtifactWaveProgress({ row }) {
    if (["ARTIFACT_PUBLICATION_STATE_PENDING", "ARTIFACT_PUBLICATION_STATE_DECLINED"].includes(row.publicationState)) return <div>Not started</div>;
    if (row.audienceKind === "ARTIFACT_AUDIENCE_KIND_TENANT_PREVIEW") return <div>All preview endpoints together</div>;
    const progress = waveProgress(row);
    if (!progress.known && !progress.complete) return <div className="text-[9px] text-[color:var(--muted-soft)]">
        {row.activeLanesTruncated ? "Lane details incomplete. Grouped advancement is unavailable." : "Wave progress unavailable. Refresh before advancing."}
    </div>;
    return (
        <div className="mt-1 grid gap-1 text-[10px]">
            <div className="font-medium text-[color:var(--ink)]">{progress.complete
                ? progress.finalWave > 0 ? "All waves completed" : "Rollout completed"
                : `Wave ${progress.currentWave} of ${progress.finalWave}`}</div>
            {progress.finalWave > 0 && <>
                <progress aria-label="Completed waves" className="h-1 w-full max-w-40 accent-[color:var(--green)]" max={progress.finalWave} value={progress.completedWaves} />
                <div>{progress.completedWaves} of {progress.finalWave} waves completed</div>
            </>}
            {progress.totalLanes > 0 && <div>{progress.completedLanes} of {progress.totalLanes} lanes completed</div>}
            {progress.lanes.length > 0 && <details>
                <summary className="cursor-pointer">Remaining lanes ({progress.lanes.length})</summary>
                <ul className="mt-1 grid gap-1">
                    {progress.lanes.map((lane) => <li key={lane.rolloutId}>
                        <span>{artifactLaneLabel(lane.laneKey)}</span>
                        <div className="text-[color:var(--muted-soft)]">Wave {lane.wavePosition} of {progress.finalWave} ({lane.wavePercent ?? 0}% eligible){lane.held ? " - held" : ""}</div>
                    </li>)}
                </ul>
            </details>}
        </div>
    );
}

export function AdvanceArtifactWaveButton({ buttonClass, disabled, onRun, row }) {
    const commands = waveAdvanceCommands(row);
    const progress = waveProgress(row);
    if (progress.complete) return null;
    const text = progress.known
        ? progress.currentWave === progress.finalWave ? "Complete final wave" : `Advance to wave ${progress.currentWave + 1}`
        : "Advance wave";
    return <button type="button" className={buttonClass} disabled={disabled || !commands.length}
        title={disabled ? "Refresh to load current wave progress before advancing." : "Advance every lane at the earliest unfinished wave. Lanes already ahead wait."}
        onClick={() => void onRun("advanceWave", commands)}>{text}</button>;
}
